import React, { useRef, useEffect, ReactNode } from 'react';

interface ClickAwayListenerProps {
    nodeRef?: React.RefObject<HTMLElement>;
    className?: string;
    onClickAway: () => void;
    children: ReactNode;
}

const ClickAwayListener: React.FC<ClickAwayListenerProps> = ({
    nodeRef,
    className,
    onClickAway,
    children,
}) => {
    const containerRef = useRef<HTMLDivElement>(null);

    const handleClickAway = (e: MouseEvent) => {
        if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
            if (nodeRef && nodeRef.current && nodeRef.current.contains(e.target as Node)) {
                return;
            }
            onClickAway();
        }
    };

    useEffect(() => {
        window.addEventListener('click', handleClickAway, true);
        return () => {
            window.removeEventListener('click', handleClickAway, true);
        };
    }, []);

    return (
        <div ref={containerRef} className={className}>
            {children}
        </div>
    );
};

export { ClickAwayListener };
